<template>
  <div class="border shadow-md p-5 h-full">
    <!-- <VimeoVideo :link="video.link" :playVideo="playVideo" /> -->
    <div v-if="video.image" class="img-container">
      <img :src="video.image" alt="shotracker" />
    </div>
    <p
      class="
        font-AvenirBlackFont
        text-gray-600
        lg:text-xl
        text-lg
        uppercase
        text-center
        mt-2
      "
      @click="handleClick"
      :class="[!playVideo ? ['cursor-pointer', 'hover:underline'] : '']"
    >
      {{ video.title }}
    </p>
  </div>
</template>

<script>
import VimeoVideo from '../../VimeoVideo.vue'

export default {
  name: 'EachVideo',

  components: {
    VimeoVideo,
  },

  props: {
    video: Object,
    playVideo: Boolean,
  },

  methods: {
    handleClick() {
      this.$router.push({
        name: 'VideosPage',
        params: { id: this.video.id },
      })

      window.location.reload()
    },
  },
}
</script>
